// Debug utility to check usage tracking
export const logUsageState = (component, state) => {
  console.log(`[${component}] Current State:`, {
    sessionTokensUsed: state.sessionTokensUsed,
    totalSpentTokens: state.totalSpentTokens,
    totalSpentCost: state.totalSpentCost
  });
  
  console.log(`[${component}] localStorage:`, {
    sessionTokens: localStorage.getItem(`${component.toLowerCase()}_session_tokens_used`),
    totalTokens: localStorage.getItem(`${component.toLowerCase()}_total_spent_tokens`),
    totalCost: localStorage.getItem(`${component.toLowerCase()}_total_spent_cost`)
  });
};